import React, { useContext } from 'react';
export const defaultTheme = {
    colors: {
        leftGutter: {
            background: 'rgba(128, 128, 128, 0.1)',
            backgroundSelected: 'rgba(96, 96, 96, 0.2)',
        },
        dragHandle: {
            edge: 'rgba(128, 128, 128, 0.5)',
            icon: 'rgba(128, 128, 128, 0.5)',
        },
        dropTarget: {
            marker: 'rgba(255, 128, 0, 0.8)',
        },
        line: {
            number: '#bbb',
        },
        heading: {
            text: '#000',
            mark: '#bbb',
        },
        listItem: {
            marker: '#ddd',
        },
        listItemCheckbox: 'rgba(200, 200, 200, 0.5)',
        inlineCode: {
            border: '#ccc',
            background: 'rgba(27, 31, 35, 0.05)',
        },
        code: {
            text: '#000',
            border: '#ccc',
            background: 'rgba(27, 31, 35, 0.05)',
        },
        thematicBreak: 'rgba(80, 80, 80, 0.5)',
        paragraph: {
            text: '#000',
        },
        blockQuote: {
            marker: '#ddd',
        },
        link: {
            text: 'blue',
            textVisited: 'purple',
        },
    },
};
const themeContext = React.createContext(defaultTheme);
export const ThemeProvider = themeContext.Provider;
export const useTheme = () => useContext(themeContext);
//# sourceMappingURL=theme.js.map